import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";
import { Link } from "react-router-dom";

import { convertDateTime, toUSDFormat } from "../../utils/utils";
import useStyles from "./buy.styles";

import cashImg from "../../assets/imgs/exchange/money.png";
import logoImg from "../../assets/imgs/injail/prisoner.png";
import mafiaImg from "../../assets/imgs/layout/game.png";

interface BuyOutPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const BuyOutPopup: React.FC<BuyOutPopupProps> = ({
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Buy out</Box>
          <Box className={classes.byBust}>
            <Box
              component={"img"}
              src={mafiaImg}
              className={classes.mafiaImg}
            />
            <Box
              className={classes.byBustUser}
              component={Link}
              to={`/profile/Capone`}
            >
              Capone
            </Box>
          </Box>
          <Box className={classes.timeLeftLabel}>Time left:</Box>
          <Box className={classes.timeLeft}>{convertDateTime(3000)}</Box>
          <Box className={classes.remainTimeBox}>
            <Box component={"img"} src={cashImg} className={classes.clockImg} />
            <Box className={classes.remainTime}>{toUSDFormat(100000)}</Box>
          </Box>
          <Button variant="contained" className={classes.attemptBut}>
            Buy out
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BuyOutPopup;
